import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Router } from '../../node_modules/@angular/router';
import { Location } from '@angular/common';
import { GenericService } from './generic.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private location: Location,
    private genericService:GenericService

  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.backButtonEvent();
     // this.genericService.googleAnalyticsInitialise();
    });
    //console.log('appinitialise');
   // localStorage.clear();
  }
  async backButtonEvent() {
    this.platform.backButton.subscribeWithPriority(999990,  () => {

      //console.log("url",this.router.url);
     
      if(this.router.url.includes('/login'))
      {
        navigator['app'].exitApp();
      }
      else
      {
        this.location.back();
      }
  });
}
 
}
